import React, {useEffect, useState} from "react" ;
import AppBodyNotificationDropdown from "root/Wieldy/ApplicationModules/Common/Body/AppBodyNotificationDropdown";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {UserTypeFilters, UserTypeTitles} from "root/DataFunctions/Constants";

const UsersAppBodyHeader= (props) =>
{
    const [data, setData] = useState({loading: true, data: []});

    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    const {pathname}  = useLocation();

    const buildHeader = (header, sub_header) =>{
        const pageHeader = <h4 className="title">{header} {sub_header}</h4>;
        return pageHeader;
    }

    const displayHeader = () =>
    {
        if(pathname.includes('/dashboard')){
            //check if we have a user's name on the url
            const user_name= queryParams.name;
            const user_name_string =  user_name !== undefined ? 'for ' + queryParams.name : '';

        return buildHeader('Dashboard', user_name_string);
        }
        else if(pathname.includes('/connections')){
            //Get the user name from the url
            const user_name_string = queryParams.name + "'s";

            return buildHeader(user_name_string, 'Connections');
        }
        else if(pathname.includes('/users'))
        {
            if(pathname.includes(UserTypeFilters.STAFF)) {
                return buildHeader(UserTypeTitles.STAFF);
            }
            else if(pathname.includes(UserTypeFilters.CHILDREN)) {
                return buildHeader(UserTypeTitles.CHILDREN);
            }
            else if(pathname.includes(UserTypeFilters.FOSTER_CARERS)) {
                return buildHeader(UserTypeTitles.FOSTER_CARERS);
            }
            else if(pathname.includes(UserTypeFilters.FOREVER_PARENTS)) {
                return buildHeader(UserTypeTitles.FOREVER_PARENTS);
            }
            else if(pathname.includes(UserTypeFilters.CONNECTED_CARERS)) {
                return buildHeader(UserTypeTitles.CONNECTED_CARERS);
            }
            else if(pathname.includes(UserTypeFilters.BIRTH_PARENTS)) {
                return buildHeader(UserTypeTitles.BIRTH_PARENTS);
            }
            else if(pathname.includes(UserTypeFilters.PROFESSIONALS)) {
                return buildHeader(UserTypeTitles.PROFESSIONALS);
            }
            else if(pathname.includes(UserTypeFilters.OTHERS)) {
                return buildHeader(UserTypeTitles.OTHERS);
            }
            else if(pathname.includes(UserTypeFilters.ARCHIVED)) {
                return buildHeader(UserTypeTitles.ARCHIVED);
            }
            else if(pathname.includes(UserTypeFilters.BLOCKED)) {
                return buildHeader(UserTypeTitles.BLOCKED);
            }
            else {
                return buildHeader(UserTypeTitles.STAFF);
            }
        }
        else{
            //Default to details
            return buildHeader(UserTypeTitles.STAFF);
        }
    }

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div className="child-menu-item">
                {displayHeader()}
            </div>

            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default UsersAppBodyHeader;
